export const rulesRuLang: RegExp = /^[А-Яа-яЁё0-9\s,.\-/:№]+$/;
export const rulesEnLang: RegExp = /^[A-Za-z0-9\s.,\-/:№]+$/;
export const rulesByLang: RegExp = /^[\u0400-\u04FF0-9\s.,-:№]+$/;
export const rulesLetterLang: RegExp =
  /^[аАбБвВгГдДеЕжЖзЗиИкКлЛмМнНоОпПрРсСтТуУфФхХцЦчЧшШщЩэЭюЮяЯ]+$/;
